import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { CartContext } from "../CartContext";
import Success from "../Components/Success";
import ReviewSlider from "../Components/ReviewSlider";
import ReactPixel from "react-facebook-pixel";
import { Helmet } from "react-helmet";
import { getData } from "../Api";

const options = {
  autoConfig: true,
  debug: false,
};
ReactPixel.init("419304844367207", options);
ReactPixel.pageView();

const ProductCarousel = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [slider, setSlider] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [showModal, setShowModal] = useState(false);

  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await getData(`/product/${slug}`);

        if (response.success) {
          setProduct(response.data);
          setSlider(response.image || []);

          ReactPixel.track("ViewContent", {
            content_ids: [response.data.id],
            content_type: "product",
            content_name: response.data.title,
            currency: "INR",
            value: response.data.discount_price,
          });
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, [slug]);

  if (!product || slider.length === 0) return <p>Loading...</p>;

  const changeSlide = (index) => {
    setCurrentImageIndex((index + slider.length) % slider.length);
  };

  const increaseQuantity = () => setQuantity(quantity + 1);

  const decreaseQuantity = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const handleAddToCart = (item) => {
    addToCart({ ...item, quantity });
    setToastMessage(`✅ ${item.title} added to cart successfully!`);
    setShowToast(true);

    ReactPixel.track("AddToCart", {
      content_ids: [item.id],
      content_type: "product",
      content_name: item.title,
      currency: "INR",
      value: item.discount_price,
    });
  };

  const handleBuyNow = async (item) => {
    await addToCart({ ...item, quantity });
    navigate("/checkout");
  };

  return (
    <>
      <Helmet>
        <title>{product.meta_title} </title>
        <meta name="description" content={product.meta_description} />
        <meta name="keywords" content={product.meta_keywords} />
      </Helmet>

      <main className="container-fluid">
        <Header />
        <div
          className="row pagebgimg py-3"
          style={{
            backgroundImage: "url('../assets/img/Breadcrumbs Banner (1).png')",
          }}
        >
          <h1 className="text-center text-success fw-bold">{product.title}</h1>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-sm-10">
            <div className="row py-5">
              <div className="col-md-6 pb-5 pb-sm-0">
                <div
                  id="productCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    {slider.map((url, index) => (
                      <div
                        key={index}
                        className={`carousel-item carousel-item33 ${
                          index === currentImageIndex ? "active" : ""
                        }`}
                      >
                        <img
                          src={`${url.image}`}
                          className="d-block w-100 main-img"
                          alt="Product"
                          onClick={() => setShowModal(true)}
                        />
                      </div>
                    ))}
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    onClick={() => changeSlide(currentImageIndex - 1)}
                  >
                    <span className="carousel-control-prev-icon"></span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    onClick={() => changeSlide(currentImageIndex + 1)}
                  >
                    <span className="carousel-control-next-icon"></span>
                  </button>
                </div>
                <div className="mt-3 justify-content-center">
                  {slider.map((url, index) => (
                    <img
                      key={index}
                      src={`${url.image}`}
                      className={`thumbnail-img mx-2 ${
                        index === currentImageIndex ? "active" : ""
                      }`}
                      style={{
                        width: "80px",
                        height: "80px",
                        cursor: "pointer",
                        border: "2px solid transparent",
                      }}
                      onClick={() => changeSlide(index)}
                      alt="Thumbnail"
                    />
                  ))}
                </div>
              </div>

              <div className="col-md-6">
                <h3>{product.title}</h3>
                <p className="text-success">Availability: In stock</p>
                <p className="mb-2">
                  <del className="text-muted">₹{product.price}</del>

                  <strong className="text-danger ms-2">
                    ₹{product.discount_price}
                  </strong>

                  <span className="text-success ms-2 fw-semibold small">
                    (
                    {Math.round(
                      ((product.price - product.discount_price) /
                        product.price) *
                        100
                    )}
                    % OFF)
                  </span>
                </p>
                <p
                  dangerouslySetInnerHTML={{ __html: product.description }}
                ></p>

                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-outline-secondary me-2"
                    onClick={decreaseQuantity}
                  >
                    -
                  </button>
                  <input
                    type="text"
                    value={quantity}
                    className="form-control text-center"
                    style={{ width: "50px" }}
                    readOnly
                  />
                  <button
                    className="btn btn-outline-secondary ms-2"
                    onClick={increaseQuantity}
                  >
                    +
                  </button>
                </div>

                <div className="mt-3">
                  <button
                    className="btn-style1"
                    onClick={() => handleAddToCart(product)}
                  >
                    Add to Cart
                  </button>
                  <Success
                    showToast={showToast}
                    setShowToast={setShowToast}
                    toastMessage={toastMessage}
                  />
                  <button
                    className="btn-style1 ms-3"
                    onClick={() => handleBuyNow(product)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>

              <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                fullscreen
              >
                <Modal.Body className="d-flex justify-content-center align-items-center position-relative bg-dark">
                  <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0 m-4 text-white"
                    onClick={() => setShowModal(false)}
                  ></button>
                  <button
                    className="position-absolute start-0 bg-light rounded-circle p-2"
                    style={{
                      left: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                    }}
                    onClick={() => changeSlide(currentImageIndex - 1)}
                  >
                    &#10094;
                  </button>
                  <img
                    className="img-fluid"
                    src={`${slider[currentImageIndex].image}`}
                    alt="LargeImage"
                    style={{ maxHeight: "90vh", maxWidth: "90vw" }}
                  />
                  <button
                    className="position-absolute end-0 bg-light rounded-circle p-2"
                    style={{
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                    }}
                    onClick={() => changeSlide(currentImageIndex + 1)}
                  >
                    &#10095;
                  </button>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>

        <section className="hero-section row align-items-center my-5">
          {/* Left Panel */}

          <div className="col-md-12  left-panel  text-center">
            <ReviewSlider />
          </div>

          {/* Right Panel */}
          {/* <div className="col-md-6 right-panel p-sm-5">
          <div className="hero__media hero__media--16105224605606f7b5 desttopview desktop_hero_media">
            <video
              loading="lazy"
              loop
              muted
              autoPlay
              onCanPlay={(e) => e.target.play()}
              onLoadedMetadata={(e) => (e.target.muted = true)}
            >
              <source src="assets/video/desktop-video.mp4" type="video/mp4" />
            </video>
          </div>
        </div> */}
        </section>
        <Footer />
      </main>
    </>
  );
};

export default ProductCarousel;
